import * as React from 'react';
import { Typography } from '@mui/material';

interface SuperScriptStrProps {
  text: String;
  sup: String | Boolean;
  style?: Object;
}

const SuperScriptStr: React.FC<SuperScriptStrProps> = ({
  text,
  sup,
  style,
}) => {
  return (
    <Typography component={'span'} sx={style}>
      <span>{text && text}</span>
      {sup ? (
        <sup style={{ marginLeft: '5px', opacity: 0.7 }}>{sup}</sup>
      ) : null}
    </Typography>
  );
};

export default SuperScriptStr;
